import React, { useState, useMemo, useLayoutEffect } from 'react';
import { useSliderState } from './Slider';
import { useTransition, config, animated } from 'react-spring';

export const FadeTrack = ({ renderItem, duration = 2000 }) => {
  const { index, items } = useSliderState();
  const [initialized, setInitialized] = useState(false);
  const transitions = useTransition(items[index], item => item.id, {
    from: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      opacity: 0,
    },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: config.molasses,
  });

  useLayoutEffect(() => {
    if (!initialized) {
      setInitialized(true);
    }
  }, [initialized]);
  return useMemo(
    () =>
      transitions.map(({ item, props, key }) => (
        <animated.div key={key} style={props}>
          {renderItem({
            item,
            i: 0,
            isCurrent: true,
            getItemProps: props => props,
          })}
        </animated.div>
      )),
    [transitions, renderItem],
  );
};

export default FadeTrack;
